/**
 * DemoBadge — an unmistakable "(Demo)" pill rendered next to any client
 * name that was seeded by scripts.seed_operational (i.e. carries the
 * `is_demo` sentinel from Mongo). Real client records never render this.
 *
 * Design intent: quiet enough not to dominate the row, unambiguous enough
 * that no partner mistakes a fictional record for a real one.
 */
import React from "react";

export const DemoBadge = ({ show = false, className = "" }) => {
  if (!show) return null;
  return (
    <span
      data-testid="demo-badge"
      className={
        "inline-flex items-center gap-1 rounded-full border border-amber-500/60 " +
        "bg-amber-50 px-2 py-[1px] text-[10px] font-mono font-medium uppercase " +
        "tracking-widest text-amber-800 dark:border-amber-500/40 dark:bg-amber-950/40 " +
        "dark:text-amber-300 " +
        className
      }
      title="Fictional demonstration record — not a real partner organization."
    >
      Demo
    </span>
  );
};

export default DemoBadge;
